export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 20
    },
    // {
    //   prop: 'image',
    //   label: '媒体文件',
    //   minWidth: 150,
    //   type: 'img',
    // },
    {
      prop: 'createtime',
      label: '创建时间',
      minWidth: 100,
    },
    {
      prop: 'weigh',
      label: '权重',
      minWidth: 50,
    },
    {
      prop: 'status',
      label: '状态',
      minWidth: 150,
    },
    {
      prop: 'type',
      label: '类型',
      minWidth: 30,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}